import {ServiceTypeConfigs} from "@umd-dit/cost-component-react"

export type LLMServiceType = 'LLM_O1' | 'LLM_O1_MINI' | 'LLM_SONNET35' | 'LLM_HAIKU35' | 'LLM_SONNET37' | 'LLM_SONNET4' | 'LLM_OPUS4'

export type ServiceType = LLMServiceType | 'TEXTRACT'

export interface LLMCost {
  inputCost: number
  outputCost: number
}

export const LLM_DISPLAY_NAMES: Record<LLMServiceType, string> = {
  'LLM_O1': 'OpenAI o1',
  'LLM_O1_MINI': 'OpenAI o1 Mini',
  'LLM_SONNET35': 'Sonnet 3.5',
  'LLM_HAIKU35': 'Haiku 3.5',
  'LLM_SONNET37': 'Sonnet 3.7',
  'LLM_SONNET4': 'Sonnet 4',
  'LLM_OPUS4': 'Opus 4'
}

export const LLM_COSTS: Record<LLMServiceType, LLMCost> = {
  'LLM_O1': { inputCost: 0.015, outputCost: 0.060 },
  'LLM_O1_MINI': { inputCost: 0.003, outputCost: 0.012 },
  'LLM_SONNET35': { inputCost: 0.003, outputCost: 0.015 },
  'LLM_SONNET37': { inputCost: 0.003, outputCost: 0.015 },
  'LLM_HAIKU35': { inputCost: 0.0008, outputCost: 0.004 },
  'LLM_SONNET4': { inputCost: 0.003, outputCost: 0.015 },
  'LLM_OPUS4': { inputCost: 0.015, outputCost: 0.075 }
}

/**
 * Service type configurations with labels only.
 * Icons and variants are now handled by the cost module with defaults (ZapIcon + outline variant).
 */
export const SERVICE_TYPE_CONFIGS: ServiceTypeConfigs = {
  // Document processing service
  'TEXTRACT': {
    label: 'Text Extraction'
  },
  
  // OpenAI services
  'LLM_O1': {
    label: LLM_DISPLAY_NAMES.LLM_O1
  },
  'LLM_O1_MINI': {
    label: LLM_DISPLAY_NAMES.LLM_O1_MINI
  },
  
  // Claude 4.x services (latest)
  'LLM_SONNET4': {
    label: LLM_DISPLAY_NAMES.LLM_SONNET4
  },
  'LLM_OPUS4': {
    label: LLM_DISPLAY_NAMES.LLM_OPUS4
  },
  
  // Claude 3.x services
  'LLM_SONNET35': {
    label: LLM_DISPLAY_NAMES.LLM_SONNET35
  },
  'LLM_HAIKU35': {
    label: LLM_DISPLAY_NAMES.LLM_HAIKU35
  },
  'LLM_SONNET37': {
    label: LLM_DISPLAY_NAMES.LLM_SONNET37
  }
};